import { useTranslation } from 'react-i18next'

import { Alert, ComboBox } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { exchangeOrdersAutomaticCreationValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/constants'
import PaymentWindowInput from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/ExchangesConfiguration/PaymentWindowInput/PaymentWindowInput'

import * as Styles from './styles'

const InstantExchangeOrdersAutomaticCreationSelector = ({
  allowedPreferences,
  instantExchangeOrdersAutomaticCreation,
  setInstantExchangeOrdersAutomaticCreation,
  disabled,
  instantExchangePaymentExpiration,
  setInstantExchangePaymentExpiration,
}) => {
  const { t } = useTranslation()

  if (!allowedPreferences.includes(preferences.instantExchangeOrdersAutomaticCreation)) return null

  return (
    <Styles.Container>
      <ComboBox
        label={t('Nuevos productos solicitados')}
        value={instantExchangeOrdersAutomaticCreation}
        handleChange={e => setInstantExchangeOrdersAutomaticCreation(e.target.value)}
        menuItems={[
          {
            label: t('Automatizar cobros y envíos (Crear nuevo pedido)'),
            value: exchangeOrdersAutomaticCreationValues.automatic,
          },
          { label: t('Gestionar cobros y envíos a mano'), value: exchangeOrdersAutomaticCreationValues.manual },
        ]}
        fullWidth
        disabled={disabled}
      />
      <PaymentWindowInput
        value={instantExchangePaymentExpiration}
        onChange={setInstantExchangePaymentExpiration}
        disabled={disabled}
      />
      {instantExchangeOrdersAutomaticCreation === exchangeOrdersAutomaticCreationValues.automatic && (
        <Alert type="info">{t('El nuevo pedido se creará al recibir la solicitud de cambio')}</Alert>
      )}
    </Styles.Container>
  )
}

export default InstantExchangeOrdersAutomaticCreationSelector
